import { Navigate } from "react-router-dom";

//login
import ForgetPasswordPage from "../pages/Authentication/ForgetPassword";
import Login from "../pages/Authentication/Login";
import Logout from "../pages/Authentication/Logout";
import Register from "../pages/Authentication/Register";

//old project
import ManualPush from "pages/Notification/ManualPush";
import PushLog from "pages/Notification/PushLog";
import AppSetting from "pages/Setting/AppSetting";
import DailyUserStatistics from "pages/Statistics/DailyUserStatistics";
import PushStatistics from "pages/Statistics/PushStatistics";

import AuditionManagement from "pages/AuditionManagement";
import Edit from "pages/Edit";
import EventLog from "pages/Log/EventLog";
import OperatorList from "pages/Operator/Operator";
import RoleList from "pages/Operator/Role";
import UserManagement from "pages/User";
import CompanyManagement from "pages/Company";
import FieldCompany from "pages/MasterData/FieldCompany";
import FieldAudidionCategory from "pages/MasterData/FieldAudidionCategory";
import RoleGroup from "pages/MasterData/RoleGroup";
import ApplicationManagement from "pages/ApplicationManagement";
import InquiryList from "pages/Inquiry";
import CategoryManagement from "pages/CategoryManagement";

const ROUTES = {
  LOGIN: "/login",
  LOGOUT: "/logout",

  HOME: "/",

  DASHBOARD: "/dashboard",
  PROFILE: "/profile",
  PROFILE_SETTING: "/pages-profile-settings",

  LOGIN_HISTORY: "/user/login_history",
  USER_FEEDBACK: "/user/user_feedback",

  COMPANY_MANAGEMENT: "/company-management",
  USER_MANAGEMENT: "/user-management",

  AUDITION_MANAGEMENT: "/audition-management",

  LOCATION_LOG: "/log/location-log",
  EVENT_LOG: "/log/event-log",

  PUSH_NOTIFICATION_PUSH_LOG: "/push-notification/push-log",
  PUSH_NOTIFICATION_MANUAL_PUSH: "/push-notification/manual-push",

  STATISTICS_DAILY_USER: "/statistics/daily-statistics",
  STATISTICS_PUSH: "/statistics/push",

  SETTING: "/setting",

  OPERATOR_LIST: "/operator/list",
  OPERATOR_ROLE: "/operator/role",
  OPERATOR_ACTIVITY_LOG: "/operator/activity-logs",
  OPERATOR_PROFILE: "/operator/profile",

  APP_SETTING: "/app-setting",
  EDIT: "/edit",

  MASTER_DATA: "/master-data",
  MASTER_DATA_FIELD_COMPANY: "/master-data/field-company",
  MASTER_DATA_FIELD_AUDITION_CATEGORY: "/master-data/field-audidion-category",
  MASTER_DATA_ROLE_GROUP: "/master-data/role-group",
  APPLICATION_MANAGEMENT: "/application-management",

  INQUIRY_LIST: "/inquiry-management",
  CATEGORY_LIST: "/category-management",
};

const ROUTE_NAMES = [
  {
    link: ROUTES.LOGIN,
    name: "Login",
  },
];

const authProtectedRoutes = [
  { path: ROUTES.USER_MANAGEMENT, component: <UserManagement /> },

  { path: ROUTES.COMPANY_MANAGEMENT, component: <CompanyManagement /> },

  { path: ROUTES.AUDITION_MANAGEMENT, component: <AuditionManagement /> },

  { path: ROUTES.EVENT_LOG, component: <EventLog /> },

  { path: ROUTES.SETTING, component: <></> },

  { path: ROUTES.PUSH_NOTIFICATION_PUSH_LOG, component: <PushLog /> },
  { path: ROUTES.PUSH_NOTIFICATION_MANUAL_PUSH, component: <ManualPush /> },

  { path: ROUTES.STATISTICS_DAILY_USER, component: <DailyUserStatistics /> },
  { path: ROUTES.STATISTICS_PUSH, component: <PushStatistics /> },

  { path: ROUTES.APP_SETTING, component: <AppSetting /> },

  { path: ROUTES.OPERATOR_LIST, component: <OperatorList /> },
  { path: ROUTES.OPERATOR_ROLE, component: <RoleList /> },
  { path: ROUTES.EDIT, component: <Edit /> },

  { path: ROUTES.MASTER_DATA_FIELD_COMPANY, component: <FieldCompany /> },
  {
    path: ROUTES.MASTER_DATA_FIELD_AUDITION_CATEGORY,
    component: <FieldAudidionCategory />,
  },
  { path: ROUTES.MASTER_DATA_ROLE_GROUP, component: <RoleGroup /> },
  { path: ROUTES.APPLICATION_MANAGEMENT, component: <ApplicationManagement /> },

  { path: ROUTES.INQUIRY_LIST, component: <InquiryList /> },
  { path: ROUTES.CATEGORY_LIST, component: <CategoryManagement /> },

  // eslint-disable-next-line react/display-name
  {
    path: "/",
    exact: true,
    component: <Navigate to={ROUTES.COMPANY_MANAGEMENT} />,
  },
  { path: "*", component: <Navigate to={ROUTES.COMPANY_MANAGEMENT} /> },
];

const publicRoutes = [
  // Authentication Page
  { path: "/logout", component: <Logout /> },
  { path: "/login", component: <Login /> },
  { path: "/forgot-password", component: <ForgetPasswordPage /> },
  { path: "/register", component: <Register /> },
];

export { authProtectedRoutes, publicRoutes, ROUTE_NAMES, ROUTES };
